import { useAppSelector } from "@sso/hooks/useRedux";
import { selectProductQuery } from "@sso/store/slices/product";

import { useProductSummariesQuery } from "..";

export const useGetProductSummariesQuery = () => {
  const queryParams = useAppSelector(selectProductQuery);
  return useProductSummariesQuery(queryParams);
};
